import axios from "axios";

export const getUsers = async (page, filters = {}) => {
  try {
    const brear = localStorage.getItem("token");

    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.get("/v1/admin/users", {
      params: {
        page,
        ...filters
      },

      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const getUsersStats = async () => {
  try {
    const brear = localStorage.getItem("token");

    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.get("/v1/admin/users/stats", {
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const showUser = async (id) => {
  try {
    const brear = localStorage.getItem("token");

    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.get(`/v1/admin/users/${id}`, {
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};


export const showUsersStats = async (id) => {
  try {
    const brear = localStorage.getItem("token");

    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.get(`/v1/admin/users/${id}/stats`, {
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};


export const updateUser = async (postData, id) => {
  try {
    const brear = localStorage.getItem("token");

    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.post(`/v1/admin/users/${id}`, postData,{
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const getUserAddresses = async (id) => {
  try {
    const brear = localStorage.getItem("token");

    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.get("/v1/admin/addresses", {
      params: {
        addressable_id: id,
        addressable_type: "user",
      },
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};
